import { useState } from 'react';
import { Box, Container, Typography, Grid, Card, CardContent, Button, Accordion, AccordionSummary, AccordionDetails, Divider } from '@mui/material';
import scholarship1 from '../assets/banner1.png';
import scholarship2 from '../assets/banner2.png';
import scholarship3 from '../assets/banner3.png';
import scholarship4 from '../assets/banner4.png';
import scholarship5 from '../assets/banner6.png';
import scholarship6 from '../assets/banner9.png';
import scholarship8 from '../assets/banner11.png';
import scholarship9 from '../assets/banner12.png';
import scholarship7 from '../assets/banner10.png';
import scholarship10 from '../assets/banner13.png';
import EmojiEventsIcon from '@mui/icons-material/EmojiEvents';
import SchoolIcon from '@mui/icons-material/School';
import StarIcon from '@mui/icons-material/Star';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import HowToRegIcon from '@mui/icons-material/HowToReg';
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import CardGiftcardIcon from '@mui/icons-material/CardGiftcard';
import MenuBookIcon from '@mui/icons-material/MenuBook';
import AutoPopUp from './AutoPopUp';

const Offers = () => {
    const [openPopup, setOpenPopup] = useState(false);

    const handleClosePopup = () => {
        setOpenPopup(false);
    };

    return (
        <Box sx={{ bgcolor: '#f8f9fa', py: 8, mt: 10 }}>
            <Container maxWidth="lg">
                <Box sx={{ textAlign: 'center', mb: 6 }}>
                    <Typography
                        variant="h2"
                        sx={{
                            fontWeight: 700,
                            color: '#1a237e',
                            mb: 2,
                            fontSize: { xs: '2rem', md: '3rem' }
                        }}
                    >
                        🎉 Special Offer at Aakash Yelahanka
                    </Typography>
                    <Typography
                        variant="h6"
                        sx={{
                            color: '#555',
                            maxWidth: '800px',
                            mx: 'auto',
                            lineHeight: 1.8
                        }}
                    >
                        Join Aakash Yelahanka today and get exclusive discounts on NEET, JEE & foundation coaching admissions for a limited time!. Unlock your potential with Aakash Yelahanka trusted coaching institute.
                    </Typography>
                </Box>

                <Grid container spacing={4} sx={{ mb: 6 }}>
                    {[scholarship1, scholarship2, scholarship4, scholarship5, scholarship6, scholarship7, scholarship8, scholarship9, scholarship10].map((item, index) => (
                        <Grid item xs={12} md={4}>
                            <Box
                                component="img"
                                src={item}
                                alt="Aakash Yelahanka"
                                sx={{
                                    width: '100%',
                                    height: 'auto',
                                    borderRadius: 3,
                                    boxShadow: '0 8px 24px rgba(0,0,0,0.12)',
                                    transition: 'transform 0.3s ease',
                                    '&:hover': {
                                        transform: 'scale(1.02)'
                                    }
                                }}
                            />
                        </Grid>
                    ))}
                </Grid>

                <Box
                    sx={{
                        bgcolor: '#e3f2fd',
                        borderRadius: 3,
                        p: 5,
                        mb: 6,
                        textAlign: 'center',
                        border: '2px solid #2196f3'
                    }}
                >
                    <Typography variant="h4" sx={{ fontWeight: 700, color: '#1a237e', mb: 3 }}>
                        A Message to All Students
                    </Typography>
                    <Typography variant="h6" sx={{ color: '#555', lineHeight: 1.8, fontStyle: 'italic', textAlign: 'left' }}>
                        🎓 Aakash Yelahanka is offering special admission discounts for students joining our coaching programs this year.
                        <br/>📚 Get expert faculty, top study materials, and excellent results for NEET, JEE & foundation courses.
                        <br/>✅ Limited period offer – Join now and secure your future with Aakash Yelahanka!
                    </Typography>
                </Box>

                <Box
                    sx={{
                        bgcolor: 'white',
                        borderRadius: 3,
                        p: { xs: 3, md: 5 },
                        boxShadow: '0 8px 24px rgba(0,0,0,0.1)',
                        textAlign: 'center'
                    }}
                >
                    <Typography variant="h4" sx={{ fontWeight: 600, color: '#1a237e', mb: 2 }}>
                        Ready to Begin Your Journey?
                    </Typography>
                    <Typography variant="body1" sx={{ color: '#666', mb: 4 }}>
                        Take the first step towards your dream career. Apply now for the Aakash Talent Search Examination.
                    </Typography>
                    <Button
                        variant="contained"
                        size="large"
                        sx={{
                            bgcolor: '#ff6b35',
                            px: 6,
                            py: 2,
                            fontSize: '1.2rem',
                            fontWeight: 600,
                            '&:hover': {
                                bgcolor: '#e55a2b',
                                transform: 'scale(1.05)'
                            },
                            transition: 'all 0.3s ease'
                        }}
                        onClick={() => setOpenPopup(true)}
                    >
                        Apply for Scholarship Now
                    </Button>
                </Box>
            </Container>
            <AutoPopUp isOpen={openPopup} onClose={handleClosePopup} />
        </Box>
    );
};

export default Offers;